import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import SemesterSubjects from "../components/SemesterSubjects";
import { useSite } from "../context/SiteContext";
import { IMAGES } from "../data/site";

export default function Students() {
  const { students, settings } = useSite();
  const p = settings.pages.student;
  const intro = settings.student;
  const gallery = (settings.images && settings.images.gallery) || IMAGES.students;
  return (
    <div data-testid="student-page">
      <PageHero label={p.label} title={p.title} subtitle={p.subtitle} />

      <section className="bg-bone py-20 md:py-28">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center mb-20">
            <Reveal className="lg:col-span-6">
              <div className="overflow-hidden rounded-sm">
                <img src={gallery} alt="Students at Kanggui Christian College" className="w-full object-cover aspect-[4/3]" />
              </div>
            </Reveal>
            <Reveal delay={0.1} className="lg:col-span-6">
              <h2 className="font-serif text-4xl md:text-5xl text-forest tracking-tight leading-none">{intro.introTitle}</h2>
              <p className="text-muted leading-relaxed mt-6">{intro.introText}</p>
            </Reveal>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line">
            {students.map((s, i) => (
              <Reveal key={s.id || s.title || i} delay={(i % 3) * 0.05}>
                <div data-testid="student-item" className="bg-bone p-8 md:p-10 h-full group hover:bg-gold transition-colors duration-300">
                  <span className="font-mono text-sm text-gold group-hover:text-forest transition-colors">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-serif text-2xl md:text-3xl text-forest mt-6">{s.title}</h3>
                  <p className="text-muted group-hover:text-forest/80 transition-colors leading-relaxed mt-3">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <SemesterSubjects />
    </div>
  );
}
